import { useState, useEffect } from 'react';
import { Grid, TextField } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { FormButton } from '../../../../components';
import { resetPassword } from '../../../../service/CognitoAuthService';

export default function ResetPass({ email, setHandleErrors, setIsEmailSent, handleClose }) {
  const useStyles = makeStyles({
    input: {
      background: 'white',
    },
  });
  const classes = useStyles();

  useEffect(() => {
    const a = 5;
    return () => {
      setIsEmailSent(true);
      setHandleErrors({
        showAlert: false,
        type: '',
        title: '',
        description: '',
      });
    };
  }, [setIsEmailSent, setHandleErrors]);

  const schemeForgotPass = yup.object({
    code: yup.number().typeError('you must specify a number').required('Required'),
    password: yup.string().required('Required'),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref('password'), null], "Passwords don't match!")
      .required('Required'),
  });
  const formikForgotPass = useFormik({
    enableReinitialize: true,
    initialValues: {
      code: '',
      password: '',
      confirmPassword: '',
    },
    validationSchema: schemeForgotPass,
    onSubmit: async (values, errors) => {
      console.log('Send reset pass ', errors);
      setHandleErrors({
        showAlert: false,
      });
      try {
        const result = await resetPassword(values.code, values.confirmPassword, email);
        if (result) {
          setIsEmailSent(false);
        }

        setHandleErrors(() => ({
          showAlert: true,
          type: 'success',
          title: 'Password changed',
          description: 'Now you can log in with your new password',
        }));
        setTimeout(() => {
          handleClose();
          setIsEmailSent(true);
        }, 3000);
      } catch (err) {
        const { code, message } = err;
        let msjError = '';
        if (code === 'InvalidPasswordException') {
          const messageSplitted = message.split(':');
          if (messageSplitted.length > 1) {
            const index = 1;
            msjError = messageSplitted[index];
          }
        } else if (code === 'InvalidParameterException') {
          msjError = 'Parameters are not valid';
        } else {
          msjError = message;
        }
        setHandleErrors(() => ({
          showAlert: true,
          type: 'error',
          title: '',
          description: msjError,
        }));
      }
    },
  });

  return (
    <form id="mail2" style={{ width: '100%' }} onSubmit={formikForgotPass.handleSubmit}>
      <TextField
        inputProps={{
          className: classes.input,
          maxLength: 6,
        }}
        style={{ marginTop: '5px' }}
        fullWidth
        id="code"
        name="code"
        autoComplete="off"
        placeholder="Code"
        type="text"
        value={formikForgotPass.values.code}
        onChange={formikForgotPass.handleChange}
        error={formikForgotPass.touched.code && Boolean(formikForgotPass.errors.code)}
        helperText={formikForgotPass.errors.code && formikForgotPass.errors.code}
      />
      <p style={{ fontSize: '11px' }}>
        Enter new password that must contain uppercase letters, numbers and special symbols and be
        at least 10 characters long
      </p>
      <TextField
        inputProps={{ className: classes.input }}
        style={{ marginTop: '5px' }}
        fullWidth
        s
        id="password"
        name="password"
        placeholder="New Password"
        type="password"
        value={formikForgotPass.values.password}
        onChange={formikForgotPass.handleChange}
        error={formikForgotPass.touched.password && Boolean(formikForgotPass.errors.password)}
        helperText={formikForgotPass.errors.password && formikForgotPass.errors.password}
      />
      <TextField
        inputProps={{ className: classes.input }}
        style={{ marginTop: '5px' }}
        fullWidth
        autoComplete="off"
        id="confirmPassword"
        name="confirmPassword"
        placeholder="Repeat password"
        type="password"
        value={formikForgotPass.values.confirmPassword}
        onChange={formikForgotPass.handleChange}
        error={
          formikForgotPass.touched.confirmPassword &&
          Boolean(formikForgotPass.errors.confirmPassword)
        }
        helperText={
          formikForgotPass.errors.confirmPassword && formikForgotPass.errors.confirmPassword
        }
      />
      <Grid item xs={12} className="grid-space-line" />
      <FormButton type="submit">Save</FormButton>
    </form>
  );
}

ResetPass.propTypes = {
  email: PropTypes.string.isRequired,
  setHandleErrors: PropTypes.func.isRequired,
  setIsEmailSent: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};
